import React from "react";
import { useForm } from "react-hook-form";
import { Box, Grid, Typography, Button, Paper } from "@mui/material";
import RFG from "../../libs/inputs/RFG";

export default function Form({
  title,
  companies = [],
  projects = [],
  users = [],
  brands = [],
  defaultValues = {},
  onSubmit = () => { },
  onChange = () => { },
}) {
  const { handleSubmit, control } = useForm({ defaultValues, mode: "all" });

  return (
    <Box sx={{ p: 1 }}>
      <form
        onSubmit={handleSubmit((data) => {
          console.log("data submit", data);
          onSubmit(data);
        })}
      >
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 12 }}>
            <RFG
              name="action_url"
              label="Url"
              control={control}
              rules={{
                required: true,
                maxLength: 500
              }}
            >
              <input autoComplete="off" />
            </RFG>
            <RFG
              name="proxy_url"
              label="Proxy Url"
              control={control}

            >
              <input autoComplete="off" />
            </RFG>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>

            <RFG
              name="label"
              label="Label"
              control={control}
              rules={{
                required: true, maxLength: 500,
              }}
            >
              <input autoComplete="off" />
            </RFG>

            <RFG
              name="action"
              label="Action"
              control={control}
              rules={{
                required: true,
                maxLength: 30,
              }}
            >
              <input autoComplete="off" />
            </RFG>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <RFG
              name="brand"
              label="Brand"
              control={control}
              rules={{
                required: true, maxLength: 12,
              }}
            >
              <select>
                <option value={""}>Select brand name</option>
                {brands.map((brand) => <option value={brand.id}>{brand.brand_name}</option>)}
              </select>
            </RFG>

            <RFG
              name="stream_type"
              label="Stream Type"
              control={control}
              rules={{
                required: true,
                maxLength: 12,
              }}
            >
              <select>
                <option value={""}>Please select</option>
                <option value={"PTZ"}>PTZ</option>
                <option value={"MJPEG"}>MJPEG</option>
                <option value={"STREAM"}>STREAM</option>
              </select>
            </RFG>
            <Box mt={3} display="flex" justifyContent="flex-end">
              <Button type="submit" className="btn-primary" color="primary">Save</Button>
            </Box>
          </Grid>
        </Grid>
      </form>
    </Box>

  );
}
